export default "__VITE_ASSET__QzmE3l$x__"